import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-account-number",
  "use": "rt-base-account-number-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol fill=\"#55CEB3\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-base-account-number\">\r\n<path d=\"M921.1,102.4c-85-85-383.5,2-383.5,2l-3.1,3.1L69.6,572.4c-7.2,7.2-7.2,19.5,0,26.6l354.3,354.3c7.2,7.2,19.5,7.2,26.6,0\r\n\tl464.9-464.9l3.1-3.1C918.5,485.9,1005.6,186.9,921.1,102.4L921.1,102.4z M802.3,383C757.2,428,684.5,428,640,383\r\n\tc-45.1-45.1-45.1-117.8,0-162.3c45.1-45.1,117.8-45.1,162.3,0C847.4,265.2,847.4,337.9,802.3,383z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/account-number.svg
// module id = 1615
// module chunks = 228